module.exports = __webpack_public_path__ + "assets/webgl/wp_dark_wall_color.jpg.0ce85795.webp";